export default {
    pedidos: [],
    pedidosEntrada: [],
    pedido: {},
    ultimaAtualizacaoListaPedido: Date,
    ultimaAtualizacaoListaPedidosNF: Date
}